


const urlParams = new URLSearchParams(window.location.search);
const cartItemsUrlParams = urlParams.get('cartItems');

if (cartItemsUrlParams) {
    const cartItems = JSON.parse(decodeURIComponent(cartItemsUrlParams))
    let formData = {
        items: cartItems.map((cartItem) => {
            return {
                id: cartItem.id,
                quantity: cartItem.quantity,
                properties: {
                    '_Print File Link': cartItem.link,
                    '_image': cartItem.image,
                    'Project Name': cartItem.projectName
                }
            }
        })
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        window.location = window.location.href.split("?")[0];
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}